import userGetters from './users/getters'

export default {
    ...userGetters
}